module.exports = __webpack_public_path__ + "media/images/usat-logo-white-d40d4426ac70d249d6b0a68b6fdaf27c.svg";